import React from 'react'
import {Col, Row} from "react-bootstrap";
import DisplayStatus from "./DisplayStatus";
const I18n = require('react-redux-i18n').I18n;

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true});
    }

    render() {
        if (this.state.hasError) {
            return (
                <Row className="justify-content-md-center">
                    <Col lg="4" className="message-page">
                        <DisplayStatus
                            statusMessage={I18n.t("messagePage.unknownError")}
                            statusType={"error"}
                            showAlert={true}
                            dismissible={false}
                        />
                    </Col>
                </Row>
            );
        }
        return this.props.children;
    }
}